import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../abstraction/auth.service';

@Component({
  selector: 'app-quick-bar',
  templateUrl: './quick-bar.component.html',
  styleUrls: ['./quick-bar.component.scss'],
})
export class QuickBarComponent implements OnInit {
  cbuBytelimeARS = '3220001805006629450010';
  cbuBytelimeUSD = '3220001812006629450021';
  aliasBytelimeARS = 'TIENDADOLAR';
  aliasBytelimeUSD = 'TIENDADOLAR.USD';

  pesoAdolar: boolean;
  pageNumber: number;

  constructor(
    private confirmDialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
  ) {}

  ngOnInit() {
    this.pesoAdolar = true;
    this.pageNumber = this.auth.loggedUser.amounts[0] || this.auth.loggedUser.amounts[1] ? 1 : 0;
  }

  quickAction(type: number) {
    switch (type) {
      case 0:
        this.pageNumber = 1;
        break;

      case 1:
        this.router.navigate(['../change'], { relativeTo: this.route });
        break;

      case 2:
        this.router.navigate(['../investments'], { relativeTo: this.route });
        break;

      case 3:
        //this._openCuponModal();
        this.router.navigate(['../referral'], { relativeTo: this.route });
        break;

      case 4:
        this.router.navigate(['../profile'], { relativeTo: this.route });
        break;

      default:
        break;
    }
  }

  changePage(pageNum: number) {
    this.pageNumber = pageNum;
  }
}
